import { Shuffle } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo } from './node-chrome';
import { SaidaNomeada } from './node-saida';

export default function RandomizerNode({ data }: any) {
  const a = Number(data.path1Probability ?? 50);
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="randomizer"
        dados={data}
        icone={Shuffle}
        corDoTopo="bg-orange-500"
        corDoIcone="text-orange-600"
        titulo={data.label || 'Dividir o tráfego'}
        largura="w-[240px]"
      >
        <div className="mt-2 border-t border-border/40 pt-1.5">
          <SaidaNomeada id="path1" rotulo={`Caminho A · ${a}%`} cor="neutro" />
          <SaidaNomeada id="path2" rotulo={`Caminho B · ${100 - a}%`} cor="neutro" />
        </div>
      </CartaoDoNo>
    </>
  );
}
